import "./AdBanner.css";

export default function AdBanner() {
  return (
    <div className="ad-banner">
      <img
        src="https://m.media-amazon.com/images/I/61lwJy4B8PL._SX3000_.jpg"
        alt="Ad Banner"
      />
    </div>
  );
}
